/**
 * The name users see for this app (login, menu, buttons). "NP-Flow" while
 * it is NoPain's own tool (docs/decisions.md "2026-10-07 — Alt hedder NP-Flow").
 * Keep in step with apps/app/src/lib/appName.ts and apps/web/index.html.
 */
export const APP_NAME = 'NP-Flow';
